import { FacebookCustomEvent, FacebookStandardEvents } from '@xyo-network/sdk-xyo-react-js';
class FacebookEvents extends FacebookStandardEvents {
    contactInfoComplete() {
        return new FacebookCustomEvent('ContactInfoComplete');
    }
    addressInfoComplete() {
        return new FacebookCustomEvent('AddressInfoComplete');
    }
    paymentInfoComplete() {
        return new FacebookCustomEvent('PaymentInfoComplete');
    }
    transactionAttempted() {
        return new FacebookCustomEvent('TransactionAttempted');
    }
    transactionFailed() {
        return new FacebookCustomEvent('TransactionFailed');
    }
    transactionCompleted() {
        return new FacebookCustomEvent('TransactionCompleted');
    }
    upsellViewed() {
        return new FacebookCustomEvent('UpsellViewed');
    }
    upsellUnavailable() {
        return new FacebookCustomEvent('UpsellUnavailable');
    }
    upsellAccepted() {
        return new FacebookCustomEvent('UpsellAccepted');
    }
    upsellSucceeded() {
        return new FacebookCustomEvent('UpsellSucceeded');
    }
    trialStarted() {
        return new FacebookCustomEvent('TrialStarted');
    }
    upsellFailed() {
        return new FacebookCustomEvent('UpsellFailed');
    }
    testStarted() {
        return new FacebookCustomEvent('TestStarted');
    }
    funnelStarted() {
        return new FacebookCustomEvent('FunnelStarted');
    }
    funnelStartedStarted() {
        return new FacebookCustomEvent('FunnelStarted');
    }
    userClick() {
        return new FacebookCustomEvent('UserClick');
    }
    emailCollected() {
        return new FacebookCustomEvent('EmailCollected');
    }
    accountCreated() {
        return new FacebookCustomEvent('AccountCreated');
    }
    shareCompleted() {
        return new FacebookCustomEvent('ShareCompleted');
    }
    funnelCompleted() {
        return new FacebookCustomEvent('FunnelCompleted');
    }
    buyticketsCompleted() {
        return new FacebookCustomEvent('BuyTicketsCompleted');
    }
    installCompleted() {
        return new FacebookCustomEvent('InstallCompleted');
    }
    offerRequested() {
        return new FacebookCustomEvent('OfferRequested');
    }
    feedbackScoreCollected() {
        return new FacebookCustomEvent('FeedbackScoreCollected');
    }
    feedbackSourceCollected() {
        return new FacebookCustomEvent('FeedbackSourceCollected');
    }
    goodFeedbackRequested() {
        return new FacebookCustomEvent('GoodFeedbackRequested');
    }
    badFeedbackRequested() {
        return new FacebookCustomEvent('BadFeedbackRequested');
    }
}
export default FacebookEvents;
//# sourceMappingURL=index.js.map